import { render, staticRenderFns } from "./homeConfig.vue?vue&type=template&id=20bb4982&scoped=true&"
import script from "./homeConfig.vue?vue&type=script&lang=js&"
export * from "./homeConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bb4982",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2025/NewRabbit/newRabbitAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20bb4982')) {
      api.createRecord('20bb4982', component.options)
    } else {
      api.reload('20bb4982', component.options)
    }
    module.hot.accept("./homeConfig.vue?vue&type=template&id=20bb4982&scoped=true&", function () {
      api.rerender('20bb4982', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sysconfig/styleConfig/homeConfig.vue"
export default component.exports